/**
 * CartIcon Component
 * Displays a shopping cart icon with the number of items in the cart
 * 
 * @module components/CartIcon
 * @requires react
 * @requires context/CartContext
 */

import React from 'react';
import { useCart } from '../context/CartContext';
import { Link } from 'react-router-dom';

/**
 * CartIcon component
 * @returns {JSX.Element} Cart icon with item count
 */
const CartIcon = () => {
  // Get item count from cart context
  const { getItemCount } = useCart();
  const itemCount = getItemCount();

  return (
    <Link to="/cart" className="cart-icon-container">
      <div className="cart-icon">
        <i className="fas fa-shopping-cart"></i>
        {itemCount > 0 && (
          <span className="item-count">{itemCount}</span>
        )}
      </div>
    </Link>
  );
};

export default CartIcon;